import "./Google.module.css";
import Header from "@/reusable_sections/Header";
import DiscoverItalianBrewingArt from "./sections/DiscoverItalianBrewingArt";
import OmOss from "./sections/OmOss";
import TalkToASpecialistToday from "./sections/TalkToASpecialistToday";
import Footer from "@/reusable_sections/Footer";
export default function GooglePage() {
  return <div>
      <Header />
      <DiscoverItalianBrewingArt />
      <OmOss />
      <TalkToASpecialistToday />
      <Footer />
    </div>;
}